import React, { createContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem("language") || "en");
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        const response = await import(`../locales/${language}.json`);
        const loaded = response.default || {};

        // Normalize structure differences (some locales may nest keys under `categories`)
        const normalized = { ...loaded };
        const nested = loaded.categories || {};
        [
          'about',
          'contact',
          'faq',
          'terms',
          'investment',
          'privacy',
          'shortInvestment',
          
        ].forEach((key) => {
          if (normalized[key] === undefined && nested && nested[key]) {
            normalized[key] = nested[key];
          }
        });

        setTranslations(normalized);
      } catch (error) {
        console.error("Failed to load translations:", error);
      }
    };
    
    loadTranslations();
    document.documentElement.lang = language; // Update HTML lang attribute
  }, [language]);

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
    document.documentElement.lang = lang; // Update HTML lang attribute when language changes
  };

  return (
    <LanguageContext.Provider value={{ language, currentLanguage: language, translations, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => React.useContext(LanguageContext);